<app-loader *ngIf="isLoading"></app-loader>

<div class="main-container lg-view" [class.no-actions]="procedurePreApprovalRequestDetails.isRequestCompleted || procedurePreApprovalRequestDetails.isRequestObsolete">
    <h3 class="header"> Procedure Approval Request </h3>
    <h5 class="header"> by {{procedurePreApprovalRequestDetails.requestedBy}} on  {{ procedurePreApprovalRequestDetails.requestedOn | date:'MM/dd/yyyy hh:mm a':'UTC' }}
    </h5>

    <h3 *ngIf="procedurePreApprovalRequestDetails.isRequestCompleted">
        <span *ngIf="procedurePreApprovalRequestDetails.isApproved" class="text-green">APPROVED</span>
        <span *ngIf="!procedurePreApprovalRequestDetails.isApproved" class="text-red">REJECTED</span>
    </h3>
    <h5 *ngIf="procedurePreApprovalRequestDetails.isRequestCompleted">
        by {{procedurePreApprovalRequestDetails.completedBy}} on {{ procedurePreApprovalRequestDetails.completedOn | date:'MM/dd/yyyy hh:mm a':'UTC' }}
    </h5>
    <p *ngIf="procedurePreApprovalRequestDetails.isRequestCompleted && procedurePreApprovalRequestDetails.completionReason">
        Reason : {{procedurePreApprovalRequestDetails.completionReason}}
    </p>

    <h4> Please find below more details about the request :</h4>

    <ng-container
            *ngTemplateOutlet="procedurePreApprovalRequestDetails.siteName ? infoTemplate : null; context: { label: 'Site', text: procedurePreApprovalRequestDetails.siteName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="procedurePreApprovalRequestDetails.assetName ? infoTemplate : null; context: { label: 'Asset', text: procedurePreApprovalRequestDetails.assetName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="procedurePreApprovalRequestDetails.procedureName ? infoTemplate : null; context: { label: 'Procedure', text: procedurePreApprovalRequestDetails.procedureName }">
    </ng-container>

    <ng-container
            *ngTemplateOutlet="procedurePreApprovalRequestDetails.reason ? infoTemplate : null; context: { label: 'Reason', text: procedurePreApprovalRequestDetails.reason }">
    </ng-container>

    <ng-container *ngIf="procedurePreApprovalRequestDetails.procedureAssetNames?.length">
        <div class="job-details">
            <div class="job-details-text">
                <span class="label">Procedure Asset</span>
                <ul class="procedure-asset-list">
                    <li *ngFor="let pa of procedurePreApprovalRequestDetails.procedureAssetNames">
                        {{ pa }}
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>

    <ng-container
            *ngTemplateOutlet="procedurePreApprovalRequestDetails.procedureEffectiveDate ? infoTemplate : null; context: { label: 'Procedure Date', text: (procedurePreApprovalRequestDetails.procedureEffectiveDate | date:'MM/dd/yyyy') }">
    </ng-container>

    <ng-container *ngIf="procedurePreApprovalRequestDetails.isRequestObsolete">
        <div class="obsolete-request">
            <span class="text-red">This date has already been approved from another session.</span>
        </div>
    </ng-container>

    <generic-modal #procedurePreApprovalResponseModal>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure approval request</h3>
        </ng-template>

        <ng-template #modalBody>
            <div style="text-align: center;">
                <h4 style="margin-top: 0;">was successfully approved</h4>
            </div>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedurePreApprovalResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

    <generic-modal #procedurePreApprovalResponseModalError>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">The procedure approval request could not be processed</h3>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="closeProcedurePreApprovalResponseModal()">Ok</button>
        </ng-template>
    </generic-modal>

    <generic-modal #approveProcedurePreApprovalResponseModal>
        <ng-template #modalHeading>
            <h3 style="text-align: center; font-weight: 100">Add reason for approval</h3>
        </ng-template>

        <ng-template #modalBody>
            <div class="main-form">
                <form [formGroup]="approveRequestForm">
                    <fieldset>
                        <mat-form-field>
                            <mat-label>Reason</mat-label>
                            <textarea matInput formControlName="completionReason" rows="30"></textarea>
                        </mat-form-field>
                    </fieldset>
                </form>
            </div>
        </ng-template>

        <ng-template #modalActions>
            <button mat-raised-button class="secondary" type="button" (click)="onCancelApprove()">Cancel</button>
            <button mat-raised-button class="secondary" type="button" (click)="submitApprove()">Approve</button>
        </ng-template>
    </generic-modal>

</div>

<action-button-carousel *ngIf="!procedurePreApprovalRequestDetails.isRequestCompleted && !procedurePreApprovalRequestDetails.isRequestObsolete">
    <ng-template #buttonsTemplate>
        <action-button [clickAction]="onApproveRequest.bind(self)" @slideUp @fadeIn [icon]="ButtonIcons.StatusChange"
                       [name]="'Approve'"></action-button>

        <action-button [clickAction]="navigateWithData.bind(self, 'reject')" @slideUp @fadeIn [icon]="ButtonIcons.Delete"
                       [name]="'Reject'"></action-button>
    </ng-template>
</action-button-carousel>


<ng-template #infoTemplate let-label="label" let-text="text">
    <div class="job-details">
        <div class="job-details-text">
            <span class="label">{{ label }}</span>
            <span *ngIf="text">{{ text }}</span>
        </div>
    </div>
</ng-template>
